// extracted by mini-css-extract-plugin
module.exports = {"taxonomyTagsCard":"taxonomyTagsCard___1wxwz","taxonomyTagContent":"taxonomyTagContent___1U6Vk"};